<div class="modal-content">
  <div class="modal-header">
    <h4>Vizsgázót érintő események</h4>
  </div>
  <div class="modal-body">
    <div *ngIf="!isLoading">
      <div *ngIf="examEvents != null">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Bejegyzés időpontja</th>
              <th>Eseményt létrehozta</th>
              <th>Kurzus neve</th>
              <th>Bejegyzés kategória</th>
              <th>Bejegyzés információ</th>
              <th>Rendszer információ</th>
              <th>Esemény időpontja</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of examEvents">
              <td>{{event.entryCreated}}</td>
              <td>{{event.eventCreator}}</td>
              <td>{{event.courseName}}</td>
              <td>{{event.eventEntryCategory}}</td>
              <td>{{event.entryDescription}}</td>
              <td>{{event.systemMessage}}</td>
              <td>{{event.eventStart}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="examEvents == null" id="eventNotFound">
        Nem található vizsgázót érintő esemény!
      </div>
      <div class="mt-5 mb-5" *ngIf="isLoading">
        <app-loader></app-loader>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-dark" (click)="close()">Bezárás</button>
    </div>
  </div>
</div>
